import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CmsBlock from 'components/CmsBlock';

import cn from './styles.local.less';

export default class Header extends PureComponent {
  static propTypes = {
    cmsData: PropTypes.object,
  };

  render() {
    const { cmsData } = this.props;

    return cmsData && cmsData.sourse ? (
      <CmsBlock
        className={cn.root}
        content={cmsData.sourse}
        qaSelector="cms-block-header"
      />
    ) : null;
  }
}
